/**
 * react的弹框
 * config:{
     * el:渲染的react组件，必传
     * className: class名 必传
     * title:组件标题，必传
     * w:组件的宽度，选传
     * h:组件的高度，选传
     * events:传的父级事件，父子组件通信，选传
 * }
 * **/
import React from 'react'
import ReactDom from 'react-dom'
const reactDialog = {
  el: null,
  show: function (config) {
    this.el = $(`<div class=${config.className}>`).appendTo(document.body);
    //React.createElement(Tags, {data: config}, null) <Tags data={config}/>
    ReactDom.render(React.createElement(config.el, { data: config }, null), this.el[0])
    var t = window.devicePixelRatio 
    let Height = 0 
    let Width = 0 

    // 不同的缩放布局 改变视口的高度
    if(window.screen.width*t < 3000 ){ // 分辨率3000以上 不走缩放
        if(t < 2){
          Height = window.innerHeight/(1/t)
          Width = window.innerWidth/(1/t)
        } else {
          Height = window.innerHeight/0.7
          Width = window.innerWidth/0.7
        }
    }else {
        Height = window.innerHeight
        Width = window.innerWidth
    }

    

    this.el.erdsDialog({
      title: config.title,
      width: config.w || Width,
      height: config.h || Height,
      modal: true,
      iszoom:config.iszoom || false,
      snag:config.snag || false ,
      close: function () {
        // 关闭弹框放出滚动条 二级弹框不放出
        if (config.modality){
          var dom = document.getElementsByTagName("body")[0];
          dom.style.overflow = 'hidden';	
        }else {
          var dom = document.getElementsByTagName("body")[0];
          dom.style.overflow = 'auto';	
        }
       
        $(this).erdsDialog('destroy');
        ReactDom.unmountComponentAtNode($(this)[0]);
        $(`.${config.className}`).remove()
      }
    });
  },
  hide: function () {
    this.el.erdsDialog('close');
  }
}

export default reactDialog

// const reactDialog = {
//   el: null,
//   show: function (config) {
//     console.log(config,"config");
    
//     // document.documentElement.style.overflow = "hidden";
//     this.el = $(`<div class=${config.className}>`).appendTo(document.body);
//     let this_ele = React.createElement(config.el, { data: config }, null);
//     console.log('this ele', this_ele)
//     //React.createElement(Tags, {data: config}, null) <Tags data={config}/>
//     ReactDom.render(this_ele, this.el[0])
//     this.el.erdsDialog({
//       title: config.title,
//       width: config.w || window.innerWidth,
//       // height: config.h || window.innerHeight,
//       height: config.h,
//       modal: true,
//       close: function () {
//         document.documentElement.style.overflow = "auto";
//         $(this).erdsDialog('destroy');
//         ReactDom.unmountComponentAtNode($(this)[0]);
//         $(`.${config.className}`).remove()
//       }
//     });
//   },
//   hide: function () {
//     this.el.erdsDialog('close');
//   }
// }

// export default reactDialog


//erds的弹窗
/**
 *   component:弹窗的内容组件,实例  必传
     title:弹窗标题, 必传
     w:宽度, 选传
     h:高度 选传
 * **/
const erdsDialog = {
  el: null,
  show: function (config) {
    const component = config.component;
    this.el = $(`<div class="erdsDialog-wrap_${config.title}">`).appendTo(document.body);
    component.render(this.el);
    this.el.erdsDialog({
      title: config.title,
      width: config.w || window.innerWidth,
      height: config.h || window.innerHeight,
      modal: true,
      close: function () {
        $(this).erdsDialog('destroy');
        component.destroySelf();
      }
    });
  },
  hide: function () {
    this.el.erdsDialog('close');
  }
}

export { erdsDialog }



// WEBPACK FOOTER //
// app/lib/editableDialog.js